module.exports = __webpack_public_path__ + "media/images/flags/ga-4257c8ec8a129da794b2a34583d3988c.svg";